
export default {
  asyncData({ redirect, $config }) {
    const { poperHpHost } = $config
    redirect(`${poperHpHost}/cookie-policy`)
  },
}
